import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    /** Root */
    ...mapGetters(['currentUser']),   
    ...mapGetters('appConfig', [
      'currentAppConfig',
      'appCode'
    ]),   
    ...mapGetters('administrativeArea', ['administrativeArea']),
    ...mapGetters('municipality', [
      'country',
      'municipality',
      'homeRoute',
      'currentMunicipality',
      'canSelectMunicipality'
    ]),

    loadedCountry() {
      return this.$route.params.country 
        ? decodeURIComponent(this.$route.params.country) 
        : this.country
    },
    loadedMunicipality() {
      return this.$route.params.municipality 
        ? decodeURIComponent(this.$route.params.municipality) 
        : this.municipality
    }

  },
  methods: {
    ...mapActions([
      'openLanguageModal',
      'closeLanguageModal'
    ]),

    goTo(item) {
      if (item === this.selected) return
      // devDump("Currently at route", this.$route)
      // devDump("Atempting to navigate to", item)
      this.resetAccessibilityTabs()
      const targetRoute = Object.freeze({
        name: String(item.value),
        params: {
          country: this.loadedCountry,
          municipality: this.loadedMunicipality
        }
      })
      const resolved = this.$router.resolve(targetRoute)
      // devDump("target route", targetRoute)
      // devDump("resolved route", resolved)
      if (resolved) this.$router.push(targetRoute)
      this.removeFixedClass();
    },

    goToHome() {
      this.$emit('click')
      this.$emit('close-menu')
      this.$router.push({
        name: 'home',
        params: {
          country: this.loadedCountry,
          municipality: this.loadedMunicipality
        }
      })
    },

    goToCity() {
      this.$router.push({
        name: 'municipality',
        params: {
          country: this.loadedCountry, 
          municipality: this.loadedMunicipality
        }
      })
    }
  }
}
